import { render, staticRenderFns } from "./pass-code.vue?vue&type=template&id=2f987002&"
import script from "./pass-code.vue?vue&type=script&lang=js&"
export * from "./pass-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports